import * as React from 'react';

import { addModifiers, slugify } from '../../../shared/helpers';

import './Block.scss';

interface BlockHeadingProps {
  level: any;
  value: string;
}

// TODO: Improve HTML semantic by rendering heading with `h{level}` tag
export const BlockHeading = ({ level, value }: BlockHeadingProps) => (
  <div id={slugify(value)} className={addModifiers('block-head block-head__level', [level])}>
    {value}
  </div>
);
